// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/PageLayout/PageLayout'
import Home from './Home'
import CounterRoute from './Counter'
import Landing from './Landing'
import Login from './Login'
import Register from './Register'
import Content from './Content'

export const createRoutes = store => ({
  path: '/',
  indexRoute: Home,
  childRoutes: [CounterRoute(store), Landing, Login, Register, Content],
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js